import { render } from "./PVZ.vue?vue&type=template&id=518c197e&scoped=true&ts=true"
import script from "./PVZ.vue?vue&type=script&lang=ts"
export * from "./PVZ.vue?vue&type=script&lang=ts"

import "./PVZ.vue?vue&type=style&index=0&id=518c197e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518c197e"]])

export default __exports__